import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, combineLatest, of, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { showAnimation } from 'src/animations';
import { Contract } from 'src/app/lib/contract/classes';
import { ContractService } from 'src/app/lib/contract/services/contract.service';
import { Issue, IssueItem, IssueItemContractMap, TransformIssueItemsDialogComponentOutputData } from '../../../classes';
import { IIssueProviderService, ISSUE_PROVIDER_SERVICE } from '../../../interfaces';
import { IssueService } from '../../../services/issue.service';

@Component({
  selector: 'app-transform-issue-items-dialog',
  templateUrl: './transform-issue-items-dialog.component.html',
  styleUrls: ['./transform-issue-items-dialog.component.css'],
  animations: [ showAnimation ]
})
export class TransformIssueItemsDialogComponent implements OnDestroy, OnInit {

  currentIndex: number = 0;

  persistable: boolean = false;

  contracts: Contract[];
  items: IssueItem[];

  selectedItems: IssueItem[];
  itemContractMap: IssueItemContractMap[] = [];

  checked: { [key: number]: boolean } = {};

  status = new BehaviorSubject(TransformIssueItemsDialogComponentStatus.Initial);
  TransformIssueItemsDialogComponentStatus = TransformIssueItemsDialogComponentStatus;

  _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_PROVIDER_SERVICE) private _issueProviderService: IIssueProviderService,
    private _issueService: IssueService,
    private _contractService: ContractService,
    private _ref: MatDialogRef<TransformIssueItemsDialogComponent>
  ) { }

  close() {
    this._ref.close();
  }

  next() {
    if (this.currentIndex === 1 && this.setItemContractMapping.length > 0) {
      this._ref.close({
        map: this.itemContractMap
      } as TransformIssueItemsDialogComponentOutputData);
    } else if (this.currentIndex === 0) {
      this.currentIndex = 1;
    }
  }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.status.next(TransformIssueItemsDialogComponentStatus.Preparing);
    this._subscriptions.push(...[
      this._issueProviderService.issue$.pipe(
        switchMap((issue: Issue) => combineLatest([of(issue), this._contractService.getCustomerContracts(issue.issuecustomer), this._issueService.getIssueItems(issue.issueid)]))
      ).subscribe(([issue, contracts, items]) => {
        this.items = items;
        this.contracts = contracts;
        this.validate();
      })
    ]);
  }

  setItemContractMapping(contractId: number, itemId: number) {
    let index = this.itemContractMap.findIndex(x => x.item === itemId);
    if (index > -1) this.itemContractMap[index].contract = contractId;
    else this.itemContractMap.push({ 'contract': contractId, 'item': itemId });
    this.persistable = this.itemContractMap.some(x => x.contract);
  }

  stepperChanged(event: StepperSelectionEvent) {
    this.currentIndex = event.selectedIndex;
  }

  toggleItem(event: MouseEvent, item: IssueItem) {
    if (event) event.stopPropagation();
    this.checked[item.itemid] ? this.checked[item.itemid] = false : this.checked[item.itemid] = true;
    this.selectedItems = this.items.filter(x => this.checked[x.itemid]);
    for (let item of this.selectedItems) this.setItemContractMapping(item.itemcontract, item.itemid);
  }

  validate = () => this.status.next(this.items.length === 0? TransformIssueItemsDialogComponentStatus.NoItems: this.contracts.length === 0? TransformIssueItemsDialogComponentStatus.NoContracts: TransformIssueItemsDialogComponentStatus.Ready);

  get selectedItemCounter(): number {
    return Object.keys(this.checked).filter(x => x).length;
  }

}

export const TransformIssueItemsDialogComponentStatus = {
  'Initial': 0,
  'Preparing': 1,
  'Ready': 2,
  'NoItems': 3,
  'NoContracts': 4
}
